// Styles
import styled from 'styled-components'

// Core
import React, {Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// Components, actions, models, etc.
import {openModal} from 'actions/modalActions'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Image from 'components/Image'
import {PAYMENT_METHOD_MODAL} from 'constants/modalsConstants'
import {walletSelector} from 'selectors'
import FormField from './FormField'

// icons
import amexIcon from 'assets/creditCards/amex.svg'
import dinersIcon from 'assets/creditCards/diners.svg'
import discoverIcon from 'assets/creditCards/discover.svg'
import eloIcon from 'assets/creditCards/elo.svg'
import jcbIcon from 'assets/creditCards/jcb.svg'
import mastercardIcon from 'assets/creditCards/mastercard.svg'
import unionpayIcon from 'assets/creditCards/unionpay.svg'
import visaIcon from 'assets/creditCards/visa.svg'

const CreditCardIconMap: {[key: string]: string} = {
  visa: visaIcon,
  amex: amexIcon,
  diners: dinersIcon,
  discover: discoverIcon,
  elo: eloIcon,
  jcb: jcbIcon,
  mastercard: mastercardIcon,
  unionpay: unionpayIcon
}

const PaymentFormField = () => {
  const {brand, last4, email} = useSelector(walletSelector)
  const dispatch = useDispatch()
  const handleEditPayment = () => {
    dispatch(
      openModal({
        modalType: PAYMENT_METHOD_MODAL,
        mode: 'EDIT'
      })
    )
  }

  const hasCardInfo = email && last4 && brand

  return (
    <PaymentFormField.Styled
      label='Payment'
      action={
        hasCardInfo && (
          <Button
            className='edit-button'
            title='Edit'
            variant='tertiary'
            onClick={handleEditPayment}
          />
        )
      }
    >
      {hasCardInfo ? (
        <div className='payment-info'>
          <div>
            <h6 className='payment-title'>Invoice Email</h6>
            <p>{email}</p>
          </div>
          <div>
            <h6 className='payment-title'>Payment Method</h6>
            <div className='payment-card-detail'>
              {brand && (
                <Image
                  src={CreditCardIconMap[brand]}
                  width='24px'
                  height='16px'
                  className='credit-card-image'
                />
              )}
              {last4 && <p>Ending in {last4}</p>}
            </div>
          </div>
        </div>
      ) : (
        <Button
          variant='tertiary'
          title={
            <Fragment>
              <Icon className='add-payment-icon' icon='add_circle' />
              <span className='add-payment-text'>Add Payment Method</span>
            </Fragment>
          }
          onClick={handleEditPayment}
        />
      )}
    </PaymentFormField.Styled>
  )
}

PaymentFormField.Styled = styled(FormField)`
  .edit-button {
    min-width: 0;
  }

  .payment-info {
    display: flex;
    column-gap: 24px;

    p {
      margin: 0;
    }
  }

  .payment-title {
    line-height: 22px;
  }

  .credit-card-image {
    border-radius: 4px;
  }

  .payment-card-detail {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }

  .add-payment-text {
    margin-left: 4px;
  }

  .add-payment-icon {
    font-size: 1rem;
  }
`
export default PaymentFormField
